export { default } from './Checkbox';


//////////////////
// WEBPACK FOOTER
// ./~/rc-checkbox/es/index.js
// module id = 837
// module chunks = 0